import { useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"
import axios from "../utils/axios"

export default function RequirePhone({ children }) {
  const [status, setStatus] = useState("loading")
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem("access_token")
    if (!token) {
      setStatus("unauthenticated")
      return
    }

    axios
      .get("/api/auth/user/")
      .then((res) => {
        if (res.data?.requires_phone) {
          setStatus("needs_phone")
        } else {
          setStatus("ok")
        }
      })
      .catch(() => setStatus("unauthenticated"))
  }, [location.pathname])

  if (status === "loading") {
    if (location.pathname.startsWith("/onboarding")) {
      return children
    }
    return null
  }
  if (status === "unauthenticated") {
    return <Navigate to="/login" replace />
  }
  if (status === "needs_phone") {
    return <Navigate to="/complete-profile" replace />
  }
  return children
}
